/**
 * XNGAGE CONFIDENTIAL
 * __________________________
 *
 * Copyright (C) 2021 Xngage - All Rights Reserved
 *
 * All code or information contained herein is, and remains the
 * property of Xngage LLC and its customers. The intellectual
 * and technical concepts contained are proprietary to Xngage LLC
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Xngage LLC.
 */
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import {
    getCurrentCartState,
    hasOnlyQuoteRequiredProducts,
    isCartCheckoutDisabled,
} from "@insite/client-framework/Store/Data/Carts/CartsSelector";
import translate from "@insite/client-framework/Translate";
import {Clickable} from "@insite/mobius/index";
import Typography from "@insite/mobius/Typography";
import { minicartStyles } from "@monsma/App/Components/XngMiniCart/XngMiniCartStyles";
import React from "react";
import { connect} from "react-redux";

const mapStateToProps = (state: ApplicationState) => {
    const cart = getCurrentCartState(state).value;
    return {
        cart,
        hasOnlyQuoteRequiredProducts: hasOnlyQuoteRequiredProducts(cart),
        isCartCheckoutDisabled: isCartCheckoutDisabled(cart),
    };
};

type OwnProps = {cartPageUrl?: string;} & ReturnType<typeof mapStateToProps>;

const MiniCartActionButtons: React.FC<OwnProps> = ({
    cart,
    hasOnlyQuoteRequiredProducts,
    isCartCheckoutDisabled,
    cartPageUrl,
}) => {
    const subTotal = cart?.properties?.orderSubTotalDisplayOnCart || cart?.orderSubTotalDisplay;
    const isDisabled = hasOnlyQuoteRequiredProducts || isCartCheckoutDisabled || cart?.cartNotPriced;

    return (
        <>
            <StyledWrapper {...minicartStyles.minicartActionButtonsStyles}>
                <Clickable href={cartPageUrl}
                           disabled={isDisabled}
                           className="close-menu"
                           {...minicartStyles.minicartCheckoutButton}>
                    {translate("View Cart")}
                </Clickable>
                <StyledWrapper {...minicartStyles.minicartSubTotal}>
                    <Typography as="span">{translate("Subtotal:")} </Typography>
                    <Typography as="strong">{subTotal || 0}</Typography>
                </StyledWrapper>
            </StyledWrapper>
        </>
    );
};

export default connect(mapStateToProps)(MiniCartActionButtons);
